/* Kipor Mega-Menü — Öffnen per Klick und Hover-Intent,
   Schließen bei Außenklick, ESC und Fokusverlust.
   Hover nur auf Geräten mit echtem Hover (Desktop). */
(function () {
  var nav = document.querySelector('[data-kipor-mega]');
  if (!nav) return;

  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-kipor-mega-item]'));
  if (!items.length) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var HOVER_OPEN_DELAY = 100;
  var HOVER_CLOSE_DELAY = 220;

  function summaryOf(item) {
    return item.querySelector('summary');
  }

  function setExpanded(item) {
    var summary = summaryOf(item);
    if (summary) summary.setAttribute('aria-expanded', item.hasAttribute('open') ? 'true' : 'false');
  }

  function closeItem(item) {
    if (item.hasAttribute('open')) {
      item.removeAttribute('open');
      setExpanded(item);
    }
  }

  function closeAll(except) {
    items.forEach(function (item) {
      if (item !== except) closeItem(item);
    });
  }

  items.forEach(function (item) {
    var openTimer = null;
    var closeTimer = null;

    item.addEventListener('toggle', function () {
      if (item.hasAttribute('open')) closeAll(item);
      setExpanded(item);
    });

    if (canHover) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          if (!item.hasAttribute('open')) {
            item.setAttribute('open', '');
            setExpanded(item);
          }
        }, HOVER_OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          closeItem(item);
        }, HOVER_CLOSE_DELAY);
      });
    }

    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) closeItem(item);
    });
  });

  document.addEventListener('click', function (event) {
    if (!nav.contains(event.target)) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openItem = items.filter(function (item) {
      return item.hasAttribute('open');
    })[0];
    if (openItem) {
      closeItem(openItem);
      var summary = summaryOf(openItem);
      if (summary) summary.focus();
    }
  });
})();
